import axios from 'axios'
import store from '@/store'

// axios.defaults.withCredentials = true
const openApi = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
      'AppKey': process.env.VUE_APP_API_KEY,
      "Content-Type": "application/json"
    }
})

openApi.interceptors.request.use(config => {
  if (store.state.user.userToken && config.data) {
    config.data.userName = store.state.user.userToken
  }
  // if (store.state.page.sessionId && store.state.page.sessionId.length > 0) {
  //   let cookie = config.headers.Cookie
  //   if (cookie && cookie.length > 0) {
  //     cookie += `;ASP.NET_SessionId=${store.state.page.sessionId}`
  //   } else {
  //     cookie = `ASP.NET_SessionId=${store.state.page.sessionId}`
  //   }
  //   config.headers.Cookie = cookie
  // }
  return config
}, error => {
  return Promise.reject(error)
})
  
// response interceptor
openApi.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { response } = error
    return response ? response.data : Promise.reject(error)
  }
)

  
export { openApi }